<template>
  <div>
        <h3 v-if="ecosystemModules.items.label && item.item.reference_code">
          <b-badge variant="dark">
            {{item.item.reference_code | cleanentityprefix}}
          </b-badge>
        </h3>
        <h3 v-else-if="ecosystemModules.items.label && !item.item.reference_code">
          {{ecosystemModules.items.label}}
        </h3>
        <h3 v-else v-translate>
          Items
        </h3>
        <dynamic-info-text :template-html="ecosystemModules.items.templateInfoText || '<div>' + $gettext('No template') + '</div>'" :marker="marker" />
        <div v-if="item.item.shippings && item.item.shippings.length > 0">
          <hr>
          <h6 v-translate>In Shippings</h6>
          <div v-for="(shipping, index) in item.item.shippings" :key="'in-shipping' + index">
            <b-link :to="{name: 'ShippingsEdit', params: {id: shipping.id}}" target="_blank">{{ shipping.id | uuid }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(shipping.id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
            <b-button size="sm" variant="link" @click="emitData({...shipping, ...{cardType: 'shipping', normalize: true}})">
              <font-awesome-icon :icon="['far', 'eye']" />
            </b-button>
          </div>
          <hr>
        </div>
        <div v-else-if="item.item.shipping && item.item.shipping.id">
          <hr>
          <p>
            <h6 v-translate>In Shipping</h6>
            <b-link :to="{name: 'ShippingsEdit', params: {id: item.item.shipping.id}}" target="_blank">{{ item.item.shipping.id }}</b-link>
            <a href="#" @click.prevent="copyToClipboard(item.item.shipping.id)" class="text-secondary" title="Copy to Clipboard"><font-awesome-icon :icon="['far', 'copy']" size="1x" /></a>
          </p>
          <div class="text-center">
            <b-button size="sm" variant="primary" @click="$root.$emit('data-selected', {...item.item.shipping, ...{cardType: 'shipping', normalize: true}})" v-translate>
              View Detail
            </b-button>
            <b-button size="sm" variant="dark" @click="$root.$emit('Items::TrackingHistory::show', item.item)" v-translate>
              Tracking History
            </b-button>
          </div>
        </div>
        <div class="text-center" v-if="!item.item.shipping || (item.item.shippings && item.item.shippings.length > 0)">
          <b-button size="sm" @click="$root.$emit('create-shipping-from-item', item.item)" v-translate>
            Create Shipping
          </b-button>
          <b-button size="sm" variant="dark" @click="$root.$emit('Items::TrackingHistory::show', item.item)" v-translate>
            Tracking History
          </b-button>
        </div>
      </div>
</template>

<script>
import DynamicInfoText from '@/components/Maps/DynamicInfoText'

export default {
  name: 'ItemPopup',
  components: {
    DynamicInfoText
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      marker: null
    }
  },
  created() {
    console.log('ARGHJHGJHGSAJHGD', this.item)

    this.marker = {
      item_id: this.item.id,
      infoText: {
        data: this.item.item
      }
    }
  }
}
</script>